// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateServerGroupMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  description?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  matchRules?: Types.InputMaybe<
    Array<Types.ServerGroupMatchRuleInput> | Types.ServerGroupMatchRuleInput
  >;
  memberServerIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
  memberServerGroupIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type CreateServerGroupMutation = {
  __typename?: "Mutation";
  createServerGroup: {
    __typename?: "ServerGroup";
    id: string;
    name: string;
    description?: string | null;
    memberServerIds: Array<string>;
    memberServerGroupIds: Array<string>;
    matchRules: Array<{
      __typename?: "ServerGroupMatchRule";
      id: string;
      matchType: Types.ServerGroupMatchTypeEnum;
      matchKey?: string | null;
      pattern: string;
    }>;
  };
};

export const CreateServerGroupDocument = gql`
  mutation CreateServerGroup(
    $organizationSlug: ID!
    $name: String!
    $description: String
    $matchRules: [ServerGroupMatchRuleInput!]
    $memberServerIds: [ID!]
    $memberServerGroupIds: [ID!]
  ) {
    createServerGroup(
      organizationSlug: $organizationSlug
      name: $name
      description: $description
      matchRules: $matchRules
      memberServerIds: $memberServerIds
      memberServerGroupIds: $memberServerGroupIds
    ) {
      id
      name
      description
      memberServerIds
      memberServerGroupIds
      matchRules {
        id
        matchType
        matchKey
        pattern
      }
    }
  }
`;
export type CreateServerGroupMutationFn = Apollo.MutationFunction<
  CreateServerGroupMutation,
  CreateServerGroupMutationVariables
>;

/**
 * __useCreateServerGroupMutation__
 *
 * To run a mutation, you first call `useCreateServerGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServerGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServerGroupMutation, { data, loading, error }] = useCreateServerGroupMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      matchRules: // value for 'matchRules'
 *      memberServerIds: // value for 'memberServerIds'
 *      memberServerGroupIds: // value for 'memberServerGroupIds'
 *   },
 * });
 */
export function useCreateServerGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateServerGroupMutation,
    CreateServerGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateServerGroupMutation,
    CreateServerGroupMutationVariables
  >(CreateServerGroupDocument, options);
}
export type CreateServerGroupMutationHookResult = ReturnType<
  typeof useCreateServerGroupMutation
>;
export type CreateServerGroupMutationResult =
  Apollo.MutationResult<CreateServerGroupMutation>;
export type CreateServerGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateServerGroupMutation,
  CreateServerGroupMutationVariables
>;
